import React, { Component } from 'react';
import QuizForm from './components/QuizForm';
import QuizQuestions from './components/QuizQuestions';
import LoadingScreen from 'react-loading-screen';
import Results from './components/Results';

import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
        amount: 10,
        category: 'any',
        difficulty: 'easy',
        type: 'multiple',
        formCompleted: false,
        quizSubmitted: false,
        loading: false,
        results: [],
        attemptIDs: []
      };
      this.baseState = this.state
      //Alternative for not using fat arrow 
      //functions is to bind this value of the current scope with the function
      // this.handleChange = this.handleChange.bind(this);
      // this.handleSubmit = this.handleSubmit.bind(this);

    }

  handleChange= (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event)=> {
    event.preventDefault();
      this.setState({
        formCompleted: true,
        loading: true
      })
  }

  handleAnswerSubmit= (event)=>{
    event.preventDefault();
    this.toggleLoading();
    setTimeout(()=>{
      this.setState({
        quizSubmitted:true
      })
    }, 1000)
  }

  captureResults= (attempts, attemptIDs)=>{
    this.setState({
      results: attempts,
      attemptIDs
    })
  }


  toggleLoading = () =>{
    this.setState({
      loading: !this.state.loading
    })
  }

  resetState = () => {
    this.setState(this.baseState);
  }

  render() {
    const {formCompleted, quizSubmitted, loading} = this.state;
    return (
      <div className="App">
      <LoadingScreen
          loading={loading}
          bgColor='linear-gradient(to right, rgba(105, 187, 28, 0.9), rgba(4, 218, 218, 0.9))'
          spinnerColor='#55f'
          textColor='#111'
          text='Loading....'
          children = ''
        > 
        </LoadingScreen>
      {!formCompleted &&
        <QuizForm 
          state = {this.state} 
          handleSubmit = {this.handleSubmit} 
          handleChange = {this.handleChange}
        />
      } 
        {formCompleted && !quizSubmitted &&
          <QuizQuestions 
            state = {this.state} 
            captureResults = {this.captureResults} 
            toggleLoading = {this.toggleLoading}
            handleAnswerSubmit = {this.handleAnswerSubmit}
          />
        }
        {quizSubmitted &&
          <Results  
            state = {this.state} 
            toggleLoading = {this.toggleLoading}
            resetState = {this.resetState}
          />
        }      
      </div>
      )
  }
}


export default App;